import { useMemo } from "react";

import { useContainerWidth } from "@features/sales-v3/minimized-top-bar/hooks";

import {
  TileType,
  type TileDescriptor,
  type Grid,
  type RootGridLayout,
  type ReadyGrid,
} from "../types";
import { getBreakpointFromWidth, getColsFromBreakpoint } from "../utils";

export type UseGridConfig = {
  readonly tiles: TileDescriptor[] | null;
};

export const useGrid = ({ tiles }: UseGridConfig): Grid => {
  const [ref, width] = useContainerWidth();

  const breakpoint = useMemo(() => {
    return getBreakpointFromWidth(width);
  }, [width]);

  const numColumns = useMemo(() => {
    return getColsFromBreakpoint(breakpoint);
  }, [breakpoint]);

  const layouts = useMemo((): RootGridLayout[] => {
    if (breakpoint && tiles) {
      return tiles.map((tile) => {
        const layout = tile.layouts[breakpoint];
        return {
          i: tile.id,
          x: layout.x,
          y: layout.y,
          w: layout.width,
          h: layout.height,
          minW: 1,
          maxW: tile.type === TileType.METRIC ? 1 : Infinity,
          minH: tile.type === TileType.METRIC ? 1 : 2,
          maxH: 2,
        };
      });
    }
    return [];
  }, [tiles, breakpoint]);

  const data = {
    breakpoint,
    numColumns,
    layouts,
    ref,
    width,
  };

  return data as ReadyGrid;
};
